import React, { useState } from 'react';
import { Translate }       from 'react-localize-redux';
import useInterval         from '@use-it/interval';
import Img                 from 'gatsby-image';
import styled, { css }     from 'styled-components';

import { glitch, noise1, noise2, stopRotate } from './keyframes';

const Container = styled.div`
  background     : #f0f0f0;
  align-items    : center;
  display        : inline;
  flex-direction : column;
  justify-content: center;
  min-height     : calc(100vh - 3.5rem - 2.5em);
  overflow       : hidden;
  position       : relative;
  transform      : translateY(-1.75rem);

  @media (min-width: 768px) {
    margin: 0 auto;
    max-width: 1200px;
  }
`;

const KeyText = styled.div`
    position     : absolute;
    margin-top   : -15em;
    padding-left : 4em;
    color        : #C1FE00;
    font-size    : 3vw;
    width        : 100vw;
`

const LogoImage = styled.h1`
  posotion     : absolute;
  margin-top   : -22em;
  margin-bottom: 14em;
  margin-left  : auto;
  margin-right : auto;
  font-size    : 3.5vw;
  max-width    : 90%;
`;

const Image = styled(Img)`
  display: block;
  width: 100%;
`;

const StoryTitle = styled.div`
  position  : absolute;
  margin-top: -9.5em;
  text-align: center;
  width     : 100vw;

  font-family: DINCondensed-Regular;
  font-size  : 3.9vw;
  font-weight: bold;
  color      : black;
  letter-spacing: 0.5rem;
`
const StorySubTitle = styled.div`
  position  : absolute;
  margin-top: -33em;
  text-align: center;
  width     : 100vw;

  font-family: DINCondensed-Regular;
  font-size  : 1vw;
  font-weight: bold;
  color      : black;
`

const StoryContainer = styled.div`
    position  : absolute;
    margin-top: -15em;
    text-align: center;
    color     : black;
    font-size : 1.8vw;
    width     : 100vw;
`
const StoryText = styled.div`
    margin: 0.5em auto;
`

// Art direction (different aspect ratio) fix for gatsby
// https://github.com/gatsbyjs/gatsby/pull/13395#issuecomment-506402173
const ResponsiveImage = styled(Img)`
  & > div:first-child {
    padding-bottom: ${({ fluid }) => 100 / fluid[0].aspectRatio}% !important;

    @media (min-width: 768px) {
      padding-bottom: ${({ fluid }) => 100 / fluid[1].aspectRatio}% !important;
    }
  }
`;

const KeyVisual = ({ onLoad, data }) => {

  const sources = [
    data.ministryM.childImageSharp.fluid,
    {
      ...data.ministry.childImageSharp.fluid,
      media: `(min-width: 768px)`
    }
  ];
  return (
    <Container>
      {/* Key Visual */}
      <ResponsiveImage fluid={sources} loading="eager" />
      {/*
      <KeyText>
        <div>{<Translate id="cmpLandingPage.keyVisual.info.1"/>}</div>
        <div>{<Translate id="cmpLandingPage.keyVisual.info.2"/>}</div>
        <div>{<Translate id="cmpLandingPage.keyVisual.info.3"/>}</div>
      </KeyText>
      */}

      {/* Title Logo */}
      {/*
      <LogoImage >
        <Translate>
          {({ translate }) => ( <Image fluid={data.logo.childImageSharp.fluid} onLoad={onLoad} />)}
        </Translate>
      </LogoImage>
      */}
     
    {/*
      <StoryTitle>STORY</StoryTitle>
      <StorySubTitle>{<Translate id="cmpLandingPage.keyVisual.story.subtitle"/>}</StorySubTitle>

      <StoryContainer>
        <StoryText>{<Translate id="cmpLandingPage.keyVisual.story.1"/>}</StoryText>
        <StoryText>{<Translate id="cmpLandingPage.keyVisual.story.2"/>}</StoryText>
        <StoryText>{<Translate id="cmpLandingPage.keyVisual.story.3"/>}</StoryText>
        <StoryText>{<Translate id="cmpLandingPage.keyVisual.story.4"/>}</StoryText>
      </StoryContainer>
      */}

    </Container>
  );
};

export default KeyVisual;
